import { AccessTime } from "@mui/icons-material";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { formatUTCToLocal, getUserTimezone } from "../utils/timezone";

interface TimezoneDisplayProps {
  showLabel?: boolean;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
  showTime?: boolean;
}

/**
 * Component to display the current timezone
 * Can be used throughout the application to show the timezone context
 */
const TimezoneDisplay: FC<TimezoneDisplayProps> = ({
  showLabel = true,
  variant = "outlined",
  size = "small",
  showTime = false
}) => {
  const timezone = getUserTimezone();
  const [currentTime, setCurrentTime] = useState<string>(
    formatUTCToLocal(new Date(), "HH:mm:ss", timezone)
  );

  useEffect(() => {
    if (showTime) {
      const timer = setInterval(() => {
        setCurrentTime(formatUTCToLocal(new Date(), "HH:mm:ss", timezone));
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [showTime, timezone]);

  return (
    <Tooltip
      title={
        <Box>
          <Typography variant="body2">All times are displayed in your local timezone</Typography>
          <Typography variant="caption">Database timestamps are stored in UTC</Typography>
          {showTime && (
            <Typography variant="caption" display="block">
              Current time: {currentTime}
            </Typography>
          )}
        </Box>
      }
    >
      <Chip
        icon={<AccessTime fontSize="small" />}
        label={showLabel ? `Timezone: ${timezone}` : timezone}
        size={size}
        variant={variant}
        sx={{
          p: 1
        }}
      />
    </Tooltip>
  );
};

export default TimezoneDisplay;
